import type { RouteLocationNormalized, Router } from 'vue-router';

import { routenames } from '../routenames';
import { hasRoutePermissions } from '../utils';

export function permissionGuard(router: Router) {
  return async (to: RouteLocationNormalized) => {
    if (!hasRoutePermissions(to, router)) {
      return { name: routenames.noPermissions };
    }
  };
}
